<script lang="ts">
    import last from 'lodash/last';
    import NumberInput from './NumberInput.svelte';
    import TextField from './TextField.svelte';
    import {computeFromKm, getAdditionalPayment} from './service';
    import {formatValue} from './utils';

    export let computedDiffMileage: number;
    export let sum: number;
    export let defaultFinishedKmTo: number[] = [0];
    export let defaultFinishedKmPrice: number[] = [0];
    export let isSurcharge = true;

    const count = Math.max(defaultFinishedKmTo.length, defaultFinishedKmPrice.length);
    const _defaultFinishedKmTo = [...defaultFinishedKmTo, ...Array(count - defaultFinishedKmTo.length).fill(0)];
    const _defaultFinishedKmPrice = [...defaultFinishedKmPrice, ...Array(count - defaultFinishedKmPrice.length).fill(0)];

    $: finishedKmTo = _defaultFinishedKmTo;
    $: finishedKmPrice = _defaultFinishedKmPrice;

    $: finishedKmFrom = computeFromKm(finishedKmTo);
    $: finishedKmSurcharge = finishedKmTo.map((to, index) => getAdditionalPayment(computedDiffMileage, finishedKmFrom[index], to, finishedKmPrice[index]));
    $: {
        let _sum = finishedKmSurcharge.reduce((a, b) => a + b, 0);

        if(!isSurcharge) {
            _sum *= -1;
        }
        sum = _sum;
    }

    const handleAddZone = () => {
        finishedKmTo = [ ...finishedKmTo, last(finishedKmTo) + 5000 ];
        finishedKmPrice = [ ...finishedKmPrice, 0 ];
    }

    const handleRemoveZone = () => {
       if(finishedKmTo.length > 1 && finishedKmPrice.length > 1) {
        finishedKmTo = finishedKmTo.slice(0,-1);
        finishedKmPrice = finishedKmPrice.slice(0,-1);
       }
    }
</script>

{#if isSurcharge}
    <p>Přejeté kilometry – hodnoty ze stávající smlouvy</p>
{:else}
    <p>Nedojeté kilometry – hodnoty ze stávající smlouvy</p>
{/if}

{#each finishedKmTo as to, i}
<div class="zone">
    <h6>Pásmo {i+1}</h6>

    <div class="row">
        <div class="col-3">
            <TextField label="Od:">
                {formatValue(finishedKmFrom[i], 0, 'km')}
            </TextField>
        </div>

        <div class="col-3">
            <NumberInput bind:value={to} id={`to[${i+1}]`} label="Do" suffix="km" />
        </div>

        <div class="col-3">
            <NumberInput bind:value={finishedKmPrice[i]} id={`price[${i+1}]`} label="Cena" suffix="Kč" precision={2} />
        </div>

        <div class="col-3">
            <TextField label={isSurcharge ? 'Doplatek:' : 'Vrácení:'}>
                {formatValue(finishedKmSurcharge[i], 2, 'Kč')}
            </TextField>
        </div>
    </div>
</div>
{/each}

<div class="row">
    <div class="col-12">
        <button type="button" class="btn btn-primary" on:click={handleAddZone}>
            Přidat pásmo
        </button>

        <button
            type="button"
            class="btn btn-danger"
            disabled={!(finishedKmTo.length > 1 && finishedKmPrice.length > 1)}
            on:click={handleRemoveZone}
        >
            Odebrat pásmo
        </button>
    </div>
</div>

<TextField inline label={isSurcharge ? 'Doplatek za přejeté km:' : 'Vrácení za nedojeté km:'}>
    {formatValue(sum, 2, 'Kč')}
</TextField>

<style>
    .zone {
        margin-bottom: 15px;
    }
</style>